import React, { HTMLAttributes, InputHTMLAttributes, useRef } from "react"
import { sharedInputCss, SharedInputCssProps } from "components/views/atoms/forms/StyledInputs"
import styled from "styled-components"
import { Spacer } from "components/views/atoms/Atoms"
// @ts-ignore
import { lightGray } from "css/variables/_colors.scss"
import {
  completeFormElementFactory,
  CompleteFormElementProps
} from "components/views/atoms/forms/completeFormElementFactory"

const StyledFormPhoneNumberInput = styled.input`
  border: none;
  outline: none;
  width: 100%;
  height: 24px;
  color: rgba(0, 0, 0, 0.8);
`

const StyledInputWrapper = styled.div`
  ${sharedInputCss};
  display: flex;
  padding: 16px;
`

const StyledPrefixText = styled.span`
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.6);
`

const StyledVerticalLine = styled.div`
  width: 2px;
  height: 24px;
  background-color: ${lightGray};
`

type FormPrefixInputProps = {
  prefixText: string
} & HTMLAttributes<HTMLInputElement> &
  Partial<SharedInputCssProps> &
  InputHTMLAttributes<HTMLInputElement>

const FormPrefixInput = React.forwardRef<HTMLInputElement, FormPrefixInputProps>(
  ({ prefixText, name, valid = true, disabled = false, type = "text", ...props }, ref) => {
    const wrapperRef = useRef(null)

    const handleClick = () => {
      const input = wrapperRef.current.querySelector("input")
      input.focus()
    }

    return (
      <StyledInputWrapper ref={wrapperRef} onClick={handleClick} valid={valid}>
        <StyledPrefixText>{prefixText}</StyledPrefixText>
        <Spacer width={0.75} />
        <StyledVerticalLine />
        <Spacer width={0.75} />
        {/* @ts-ignore */}
        <StyledFormPhoneNumberInput type="text" name={name} ref={ref} {...props} />
      </StyledInputWrapper>
    )
  }
)

FormPrefixInput.displayName = "FormPrefixInput"

const CompletePrefixInput = completeFormElementFactory<
  HTMLInputElement,
  CompleteFormElementProps<HTMLInputElement> & FormPrefixInputProps
>(FormPrefixInput)

export { FormPrefixInput, CompletePrefixInput }
